import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=5aa77e68"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"
import style0 from "./Score.vue?vue&type=style&index=0&id=5aa77e68&prod&lang=less"
import style1 from "./Score.vue?vue&type=style&index=1&id=5aa77e68&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports